export const dayjsFormats = {
  DATE: "DD.MM.YYYY",
  TIME: "HH:mm",
}